import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleProfileCompletionModal } from '../../../../actions/common/modals';
import FoodTasting from '../../../../assets/images/profile/completion/farmers.svg';
import ProfileCompletionCompleted from './ProfileCompletionCompleted';

const texts = {
    title: 'What do you do?',
    helper: 'Select the nature of your job',
    btn: '+ Job Profile'
}
class JobProfileCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasProfileCompleted: (this.props.profile
                && this.props.profile.profile_occupations
                && !!this.props.profile.profile_occupations.length)
        }
        // binding toggle modal
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        const { toggleProfileCompletionModal } = this.props;
        toggleProfileCompletionModal('job');
    }

    componentDidUpdate() {
        if (this.props.profile
            && this.props.profile.profile_occupations
            && this.props.profile.profile_occupations.length
            && !this.state.hasProfileCompleted) {
            this.setState({
                hasProfileCompleted: true
            })
        }
    }

    render() {
        return (<div className="feed-common-cards profile-completion-card">
            <div className="profile-completion-card__image__container">
                <img className="profile-completion-card__image" src={FoodTasting} alt={texts.title} />
            </div>
            <div className="profile-completion-card__details">
                    <p className="profile-completion-card__details__title">{texts.title}</p>
                    <p className="profile-completion-card__details__helper">{texts.helper}</p>
            </div>
            <div className="profile-completion-card__action">
                <button className="profile-completion-card__action__btn" onClick={this.toggleModal}>
                    <span className="profile-completion-card__action__btn__text">{texts.btn}</span>
                </button>
            </div>
            { this.state.hasProfileCompleted && <ProfileCompletionCompleted /> }
        </div>);
    }
};

function mapStateToProps(state) {
    return {
        token: state.login.token,
    };
}

const mapDispatchToProps = {
    toggleProfileCompletionModal
}

export default connect(mapStateToProps, mapDispatchToProps)(JobProfileCard);